import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-google-reviews',
  templateUrl: './google-reviews.component.html',
  styleUrl: './google-reviews.component.scss'
})
export class GoogleReviewsComponent implements OnInit, OnDestroy {
  
  // Clean unified review dataset
  reviews = [
    {
      name: 'Somu Raj',
      image: null,
      rating: 5,
      text: 'Exceptional quality and incredible service! Finding the right variety was always a hassle until I came here. This review isn’t paid or fake — it’s just appreciation for the best tile and structural shopping experience I have ever had. Highly recommended!',
      dateAgo: '4 days ago',
      reviewUrl: 'https://www.google.com'
    },
    {
      name: 'Frank NM',
      image: null,
      rating: 5,
      text: 'Superb customer care and highly prompt delivery channels. The design layouts, depth options, and professional attention to detail are absolute top-notch. Will definitely use them for our next development projects.',
      dateAgo: 'a week ago',
      reviewUrl: 'https://www.google.com'
    },
    {
      name: 'Amina Khan',
      image: null,
      rating: 5,
      text: 'I own multiple fine-dining restaurants and houses, and finding the combination of premium durability and gorgeous layouts was a nightmare until I found Kitchen Magic. They made the process completely seamless.',
      dateAgo: '2 weeks ago',
      reviewUrl: 'https://www.google.com'
    },
    {
      name: 'Rajesh Kumar',
      image: null,
      rating: 5,
      text: 'Outstanding craftsmanship and attention to layout configuration details. The design consultants went above and beyond to make our workspace functional and visually breathtaking. A perfect 5-star team!',
      dateAgo: '3 weeks ago',
      reviewUrl: 'https://www.google.com'
    }
  ];

  visibleCount = 3;
  startIndex = 0;
  modalOpen = false;
  selectedReview: any = null;
  private autoPlayIntervalId: any = null;

  sectionTitle = [
    {
      title: 'What they say about us',
      paragraph: 'Real Google reviews from our premium clients.'
    }
  ];

  ngOnInit(): void {
    this.calculateVisibleCount();
    this.startAutoPlay();
    
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.onResize.bind(this));
    }
  }

  ngOnDestroy(): void {
    this.stopAutoPlay();
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize.bind(this));
    }
  }

  onResize(): void {
    this.calculateVisibleCount();
  }

  get visibleReviews() {
    return this.reviews.slice(this.startIndex, this.startIndex + this.visibleCount);
  }

  calculateVisibleCount(): void {
    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      if (width < 768) {
        this.visibleCount = 1;      // Phone
      } else if (width < 1150) {
        this.visibleCount = 2;     // Tablet
      } else {
        this.visibleCount = 3;     // Desktop
      }
    }
  }

  startAutoPlay(): void {
    this.stopAutoPlay();
    this.autoPlayIntervalId = setInterval(() => {
      this.nextReview();
    }, 3800); // Advances to next card view smoothly every 3.8 seconds
  }

  stopAutoPlay(): void {
    if (this.autoPlayIntervalId) {
      clearInterval(this.autoPlayIntervalId);
      this.autoPlayIntervalId = null;
    }
  }

  nextReview(): void {
    const maxIndex = this.reviews.length - this.visibleCount;
    if (this.startIndex >= maxIndex) {
      this.startIndex = 0; // Wraps back to first card smoothly
    } else {
      this.startIndex++;
    }
  }

  prevReview(): void {
    const maxIndex = this.reviews.length - this.visibleCount;
    if (this.startIndex <= 0) {
      this.startIndex = maxIndex; // Wraps to last card smoothly
    } else {
      this.startIndex--;
    }
  }

  openModal(review: any): void {
    this.selectedReview = review;
    this.modalOpen = true;
    this.stopAutoPlay();
  }

  closeModal(): void {
    this.modalOpen = false;
    this.selectedReview = null;
    this.startAutoPlay();
  }
}